import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { useInjectReducer, useInjectSaga } from 'utils/redux-injectors';
// import { signupSaga } from './saga';
import { SignupState } from './types';
import { endpoints, formatErrors, baseQuery } from 'utils/api/endpoints';
// import { signup } from 'types/signup';
export const initialState: SignupState = {
  loading: false,
  error: null,
  user: null,
  isLoggedIn: false,
};

export const api = createApi({
  reducerPath: 'signupApi',
  baseQuery,
  endpoints: build => ({
    signup: build.mutation<any, any>({
      query: body => {
        return {
          ...endpoints.register,
          body,
        };
      },
    }),
    sendOtp: build.mutation<any, any>({
      query: body => {
        return {
          ...endpoints.sendOtp,
          body,
        };
      },
      transformErrorResponse(baseQueryReturnValue, meta, arg) {
        return formatErrors(baseQueryReturnValue.data);
      },
    }),
    verifyOtp: build.mutation<any, any>({
      query: body => {
        return {
          ...endpoints.verifyOtp,
          body,
        };
      },
    }),
    validateUsername: build.query<any, any>({
      query: username => {
        return {
          url: endpoints.validateUsername.url + `/${username}`,
          method: 'GET',
        };
      },
    }),
  }),
});

export const useSignupSlice = () => {
  useInjectReducer({ key: api.reducerPath, reducer: api.reducer });
  return {
    useSignupMutation: api.useSignupMutation,
    useSendOtpMutation: api.useSendOtpMutation,
    useVerifyOtpMutation: api.useVerifyOtpMutation,
    useValidateUsernameQuery: api.useLazyValidateUsernameQuery,
  };
  // useInjectSaga({ key: slice.reducerPath, saga: signupSaga });
  // return { actions: slice.actions };
};
